import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'events',
    pathMatch: 'full'
  },
  
  {
    path: 'events',
    loadChildren: './pages/events/events.module#EventsPageModule',
    canActivate: [AuthGuard]
  },

  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
   
  },

  { 
    path: 'events',
    children: [
      {
        path : '',
        loadChildren: './pages/events/events.module#EventsPageModule',
        canActivate: [AuthGuard]
      },

      {
        path : ':eventId',
        loadChildren: './pages/tickettypes/tickettypes.module#TickettypesPageModule',
        canActivate: [AuthGuard]
      }
      ]
  },

  {
    path: 'eventattendees',
    children: [
      {
        path : '',
        loadChildren: './pages/eventattendees/eventattendees.module#EventattendeesPageModule',
        canActivate: [AuthGuard]
      },
      {
        path : ':attnEventId',
        loadChildren: './pages/eventattendees/eventattendees.module#EventattendeesPageModule',
        canActivate: [AuthGuard]
      }
      ]
  },

  {
    path: 'eventattendeesmanualadd',
    children: [
      {
        path : ':attnEventId',
        loadChildren: () => import('./pages/eventattendeesmanualadd/eventattendeesmanualadd.module').then( m => m.EventattendeesmanualaddPageModule),
        canActivate: [AuthGuard]
        }
      ]
  },

  {
    path: 'attendees',
    children: [
      {
        path : ':ticketTypeId',
        loadChildren: './pages/attendees/attendees.module#AttendeesPageModule',
        canActivate: [AuthGuard]
        }
      ]
  },

  {
    path: 'emailanattendee',
    children: [
      {
        path : ':attendeeId',
        loadChildren: () => import('./pages/emailanattendee/emailanattendee.module').then( m => m.EmailanattendeePageModule),
        }
      ]
  },
  
  {
    path: 'emaileventattendees',
    children: [
      {
        path : ':eventId',
        loadChildren: () => import('./pages/emaileventattendees/emaileventattendees.module').then( m => m.EmaileventattendeesPageModule),
        canActivate: [AuthGuard]
        }
      ]
  },

  {
    path: 'emailticketattendees',
    children: [
      {
        path : ':ticketTypeId',
        loadChildren: () => import('./pages/emailticketattendees/emailticketattendees.module').then( m => m.EmailticketattendeesPageModule),
        canActivate: [AuthGuard]
        }
      ]
  },
  {
    path: 'thankyouevent',
    loadChildren: () => import('./pages/thankyouevent/thankyouevent.module').then( m => m.ThankyoueventPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'thankyouticket',
    loadChildren: () => import('./pages/thankyouticket/thankyouticket.module').then( m => m.ThankyouticketPageModule),
    canActivate: [AuthGuard]
  },
  { 
    path: 'publishticket',
    children: [
      {
        path : '',
        loadChildren: () => import('./pages/publishticket/publishticket.module').then( m => m.PublishticketPageModule),
        canActivate: [AuthGuard]
      },

      {
        path : ':ticketId',
        loadChildren: () => import('./pages/formpublishticket/formpublishticket.module').then( m => m.FormpublishticketPageModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'thankyoueventedit',
    loadChildren: () => import('./pages/thankyoueventedit/thankyoueventedit.module').then( m => m.ThankyoueventeditPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'thankyouticketedit',
    loadChildren: () => import('./pages/thankyouticketedit/thankyouticketedit.module').then( m => m.ThankyouticketeditPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'create',
    loadChildren: () => import('./pages/create/create.module').then( m => m.CreatePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'myaccount',
    loadChildren: () => import('./pages/myaccount/myaccount.module').then( m => m.MyaccountPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'updatevendorinfo',
    loadChildren: () => import('./pages/updatevendorinfo/updatevendorinfo.module').then( m => m.UpdatevendorinfoPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'modal',
    loadChildren: () => import('./pages/modal/modal.module').then( m => m.ModalPageModule)
  },
  {
    path: 'resetpassword',
    loadChildren: () => import('./pages/resetpassword/resetpassword.module').then( m => m.ResetpasswordPageModule)
  },
  {
    path: 'thankyouppublishticket',
    loadChildren: () => import('./pages/thankyouppublishticket/thankyouppublishticket.module').then( m => m.ThankyouppublishticketPageModule)
  },
  {
    path: 'deleteaccount',
    loadChildren: () => import('./pages/deleteaccount/deleteaccount.module').then( m => m.DeleteaccountPageModule)
  },
  {
    path: 'ordersuccess',
    loadChildren: () => import('./pages/ordersuccess/ordersuccess.module').then( m => m.OrdersuccessPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
